import { render } from "./ChangePassword.vue?vue&type=template&id=b5cdefae&ts=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__